export function decodeHtml(value = ''): string {
  if (!value) return ''

  if (process.server) {
    return value
      .replace(/&reg;/g, '®')
      .replace(/&trade;/g, '™')
      .replace(/&amp;/g, '&')
      .replace(/&nbsp;/g, ' ')
  }

  const parser = new DOMParser()
  return (
    parser.parseFromString(value, 'text/html').documentElement
      .textContent ?? ''
  )
}
